<template>  
	<div>
		<!---<div class="overlay" v-if="isHidden"></div>
		
        <div  >
			<div class="right_top_btnsec" :class="(parseInt(this.$store.getters['GET_USER'].step) >= 10)?'':'message_strip'">
                <div class="row ">
                    <div class="col-6">
						<div v-if="parseInt(this.$store.getters['GET_USER'].step) !== 10">
						    <span class="registerationMesssage" v-if="this.$store.getters['GET_USER'].hold_reason.length !== 0 && parseInt(this.$store.getters['GET_USER'].step) != 8 && parseInt(this.$store.getters['GET_USER'].step) != 23">Your registration is on hold. Click 
								<router-link :to="'/required/document/verification'"> here </router-link> to know more!
							</span>
                            <span class="registerationMesssage" v-else-if="parseInt(this.$store.getters['GET_USER'].step) == 8">
                                Your account opening process is complete. Please wait to receive your trading credentials. 
                                Your account process is complete. You will shortly receive an email with your trading software credentials.
                            </span>
							<span v-else-if="parseInt(this.$store.getters['GET_USER'].step) == 7">
								<span class="registerationMesssage" v-if="!(categorization_list.length > 0 && !categorization_list[0].ncdex && !categorization_list[0].mcx)">To confirm your categorization before Esigning the KYC 
									<router-link :to="'/Segments/segment'"> click here
									</router-link> 
								</span>
								<span class="registerationMesssage" v-else>All set. Lets Esign your KYC. 
									<router-link :to="'/required/document/verification'"> click here
									</router-link> 
								</span>
							</span>
							<span class="registerationMesssage" v-else>We are verifying your documents and will update you shortly via email and sms</span>
						</div>  
						<div v-else>  
                            <div class="p_searchscrip pull-left mr-5">
                                <form>
                                    <div class="searchscrip_form form-group mb-0 pl-3">
                                        
                                        <div class="main_headsec col-sm-12 mt-2"> 
                                            <h1 class="pull-left">DASHBOARD</h1> 
                                        </div>
                                      
                                    </div>
                                </form>
                            </div>
						</div>
                    </div>
                    <div class="col-6 padding-left"> 
                        <div class="pay_inout_sec d-flex align-items-center pull-right">
                           
                            <div  class="profilelogo rightsidebar_menu">
                                <a :title="get_user.username" v-on:click="open_div()" href="#" class="usernameicon dropdown-toggle">
                                	{{get_user.username.charAt(0)}}
	                            </a>
                                <div class="rightmenu" v-if="side_menu">
								<vue-scroll> 
									  <div class="scrollItem">
                                    <div class="top_headbar">
                                        <div class="text-center custom_height mt-4 mb-4">
                                            <a href="#" class="userthumb" v-if="get_user.profile.passport_image != ''">
                                                <img :src="esign_adhar_doc_url_user+get_user.profile.passport_image +'&id='+get_user.profile.pid+ '&signed=0&profile=1'" height="100" width="100" /> 
                                            </a>
                                            <a href="#" class="userthumb" v-else>
                                                <img src="../../../../static/prism/images/user_icon1.png" height="100" width="100" /> 
                                            </a>
                                            <a class="close_btn" @click="close_div()">
                                                <i class="fa fa-close"></i>
                                            </a>
                                        </div>
                                        <div class="balance">
                                            <h1 v-if="(Object.keys(margin_info_list).length > 0)">
                                                <small>Account Balance:</small>₹ {{ numberWithCommas(margin_info_list.Netcashavailable) }}
                                            </h1>
                                            <h1 v-else>
                                                <img src="../../../../static/prism/images/prism_loader.svg" width="50px"/>
                                            </h1>
                                        </div>
                                    </div>
                                    <ul class="text-left" @click="close_div()">
                                        <li>
                                            <router-link :to="'/Users/profile'">
                                                My Profile
                                            </router-link>
                                        </li>
                                     
                                        <li v-if="((profile_list != '') && (parseInt(profile_list.result[0].MCX) == 1 || parseInt(profile_list.result[0].NCDEX) == 1))">
                                            <router-link :to="'/Segments/segment'">
                                                categorization
                                            </router-link>
                                        </li>
                                     
                                        <li>
                                            <a title="Chat With Us" href="https://direct.lc.chat/12465924/1" target="_blank()">
                                                Chat With Us
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" @click="logout()">
                                                 Log Out
                                            </a>
                                        </li>
                                    </ul>
                                 </div>
								</vue-scroll>
                                </div>
								
							
                            </div>
                        </div>
                     

                    </div>

                </div>

            </div>
	        
        </div>
        
---->
	</div>
</template>
<script>   
    // import { Const }  from '@/plugins/prism/provider/candle-history/lib/const.cls'
    import * as types from '@/types'
    import { mapActions } from 'vuex'  
    import { prismMixins } from '@/plugins/prism'
    import { ProviderCacheMixins } from '@/plugins/vue-provider-cache/mixin'
    import SearchBar from './search_bar'
    import { CreditCardIcon, ShoppingCartIcon } from 'vue-feather-icons'

    export default{
        name: 'PrismApp',
        mixins: [prismMixins, ProviderCacheMixins],    
        data(){
            return {
				counter : 1,
                search_text:'',
                isHidden: false,
                side_menu: false,
                search_text_children : "",
                
			}
        },
		methods:{
            
            open_div() {
                this.side_menu = true
                this.isHidden = true
            },
            close_div() {
                this.side_menu = false
                this.isHidden = false
            },
			...mapActions({
				_runLogout: types.RUN_USER_LOGOUT
			}),
			logout(){
				const r = this.$router
				this._runLogout({
					router: r,
					parameter: this
				})
			},
			
		},
        created(){
            // this.searchCache();
			
			if(parseInt(this.get_user.step) < 10){
                console.log('this.rout')
				this._rungetCategorization({"rout" : this.rout ,"parameter" : this})
			}
            
			
        },
        mounted(){
            $(".showstocklist").focusin(function(){
                //console.log("yes-------------")
              });
            $(".showstocklist").focusout(function(){
               // console.log("out-------------",$(this).val());
               
                this.search_text =  $(this).val("");
                //console.log("after-------------",this.search_text)
            });
        },
        components: {
          SearchBar: SearchBar,
          CreditCardIcon,
          ShoppingCartIcon
        },
    }
</script> 


// WEBPACK FOOTER //
// src/components/prism/shared/header.vue